import React, { useContext } from "react";
import CustomAutoComplete from "./CustomAutoComplete";
import ProductContext from "../contexts/ProductContext";
// import CustomInput from "./CustomInput";
import "./styles.scss";
// import CustomSelect from "./CustomSelect";

const SearchableDropdown = ({ items }) => {
  const context = useContext(ProductContext);
  if (items?.length <= 0) return;

  const { defaultKeyword } = context;

  return <CustomAutoComplete items={items} defaultValue={defaultKeyword} />;
  // let options = [];
  // items?.map((item) => {
  //   if (item.category_name === "bbbb" || item.category_name === "aaaa")
  //     return null;
  //   options.push({ value: item.category_id, label: item.category_name });
  // });
  // return (
  //   <CustomSelect
  //     options={options}
  //     defaultValue={defaultKeyword}
  //     className="SearchableDropdown"
  //     classNamePrefix="select"
  //     name="color"
  //     isClearable
  //     isSearchable
  //   />
  // );
};

export default SearchableDropdown;
